<template>
    <div>
        <div class="outTopBox">
            <top-bread :bread="bread" v-if="curPage==='/indexShow'">
                <span slot="second">首页</span>
                <span slot="third">更多</span>
                <span slot="fourth">详情</span>
            </top-bread>
            <top-bread :bread="breadTaskToDo" v-if="curPage==='/taskToDo'">
                <span slot="second">任务管理</span>
                <span slot="third">待办任务</span>
                <span slot="fourth">详情</span>
            </top-bread>
            <top-bread :bread="breadTaskDone" v-if="curPage==='/taskDone'">
                <span slot="second">任务管理</span>
                <span slot="third">已办任务</span>
                <span slot="fourth">详情</span>
            </top-bread>

        </div>
        <el-card class="box-card">
            <!--<back @backMeth="backMeth" v-if="query.editType!=='check'"></back>-->
            <el-row class="btnRow" >
                <div>
                    <back @backMeth="backMeth"></back>
                </div>
                <div v-if="query.editType==='check'" class="rightBtn">
                    <el-button type="primary" class="largeBtn passBtn" @click="pass">通过</el-button>
                    <el-button class="largeBtn redBtn" type="danger" @click="reject" v-if="auth.type!=='htrip'">驳回</el-button>
                </div>

            </el-row>
            <div class="title marginBottomTwenty">{{reconciliationType===1?'上线费用':'市场费用'}}对账单</div>
            <el-form  :model="form" class="demo-form-inline">
                <el-row v-if="query.editType==='check' && auth.type==='htrip'">
                    <el-col :span="6">
                        <el-form-item label="单价">
                            <el-input v-model="form.price" @change="priceChange">
                                <template slot="append">元 / 台</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="detailBox marginBottomTwenty">
                <span>对账单位名称：{{detail.companyName}}</span>
                <span >对账周期：{{detail.period}}</span>
            </div>
            <el-table class="marginBottomTwenty" v-if="reconciliationType!==1 && tableShow"
                      :data="tableData"
                      style="width: 100%"
                      :header-cell-style="tableStyle"
                      v-loading="tableLoading"
                      show-summary=""
                      :summary-method="getTotal">
                <!--:summary-method="summaryMeth">-->
                <el-table-column
                        prop="hotel_name"
                        label="酒店名称"
                        width="270">
                </el-table-column>
                <el-table-column
                        prop="hotel_create_time"
                        label="上线时间">
                </el-table-column>
                <el-table-column
                        prop="active_terminal_num"
                        label="激活终端数量">
                </el-table-column>
                <el-table-column
                        prop="valid_room_num"
                        label="有效激活终端数量">
                </el-table-column>

                <el-table-column prop="price" label="单价（元/台）">
                    <template   slot-scope="scope">
                        <span>{{twoPointCom(scope.row.price)}}</span>
                    </template>

                </el-table-column>
                <el-table-column
                        prop="amount"
                        label="开票金额（元）">
                    <template   slot-scope="scope">
                        <span>{{twoPointCom(scope.row.amount)}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!--上线费用-->
            <el-table class="marginBottomTwenty" v-if="reconciliationType===1 && tableShow"
                      :data="tableData"
                      style="width: 100%"
                      :header-cell-style="tableStyle" v-loading="tableLoading">
                <el-table-column
                        prop="hotelName"
                        label="酒店名称"
                        width="270">
                </el-table-column>
                <el-table-column
                        prop="settleType"
                        label="系统版式">
                </el-table-column>
                <el-table-column
                        prop="terminalNum"
                        label="终端数量">
                </el-table-column>

                <el-table-column
                        prop="checkTerminalNum"
                        label="此次验收终端数量">
                    <template slot-scope="scope">
                        <span>{{scope.row.checkTerminalNum}}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="terminalNum"-->
                        <!--label="验收时间">-->
                <!--</el-table-column>-->
                <el-table-column prop="price" label="单价（元）">
                    <template   slot-scope="scope">
                        <span>{{twoPointCom(scope.row.price)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="amount"
                        label="开票金额（元）">
                    <template   slot-scope="scope">
                        <span>{{twoPointCom(scope.row.amount)}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tips marginBottomTwenty">
                <P class="marginBottomTwenty">*对账确认期为收到对账单日起{{detail.automatic}}天。超出{{detail.automatic}}天系统自动确认此对账单</P>
                <p><span class="noneEl">*</span>确认对账单后，请按照对账单中的开票金额开具等额的增值税专用发票。我司在收到发票后进行付款。</p>
            </div>
            <el-form class="showDetailBox">
                <div class="roomBox marginBottomTwenty">
                    <el-form-item label="对账明细">
                        <span @click="roomDetailMeth">{{detail.roomDetailShow?'收起':'展开'}}</span>
                    </el-form-item>
                    <!--<div class="roomDetail" v-if="detail.roomDetailShow">-->
                    <!--<el-row :gutter="20">-->
                    <!--<el-col :span="2" :key="index" v-for="(item,index) in detail.roomList" class="roomItemBox">-->
                    <!--<div class="roomItem">{{item.valid_room_number}}</div>-->
                    <!--</el-col>-->
                    <!--</el-row>-->
                    <!--</div>-->
                    <div v-if="detail.roomDetailShow">
                        <div class="outItem" :key="indexOut" v-for="(itemOut,indexOut) in detail.roomList"  >
                            <div class="top">
                                <span>{{indexOut}}</span>
                            </div>
                            <div class="bottom">
                                <el-row :gutter="20">
                                    <el-col :span="2" :key="indexInner" v-for="(itemInner,indexInner) in itemOut" class="roomItemBox">
                                        <div class="roomItem">{{itemOut[indexInner]}}</div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="checkPic" v-if="reconciliationType===1">
                    <el-form-item label="酒店验收单">
                        <span @click="urlDetailMeth">{{detail.urlDetailShow?'收起':'展开'}}</span>
                    </el-form-item>
                    <el-form-item label="" class="idCard" v-if="detail.urlDetailShow">
                        <el-upload  :disabled="true"
                                    :action="global.upload"

                                    list-type="picture-card"
                                    :on-preview="uploadMeth"
                                    :on-remove="uploadMeth"
                                    :on-success="uploadMeth"
                                    :on-before="uploadMeth"
                                    :on-change="uploadMeth"
                                    :file-list="detail.fileList"
                                    :headers="headers"
                                    :limit="1"
                                    :class="{disabled:true}"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="detail.checkDialogVisible">
                            <img width="100%" :src="detail.url" alt="">
                        </el-dialog>
                    </el-form-item>
                </div>
            </el-form>
            <reject-dialog ref="rejectDialog" @examine="examine"></reject-dialog>
        </el-card>
    </div>
</template>

<script>
    import GLOBAL from '../../api/globalVar.js'
    import  qs from 'querystring'

    export default {
        name: "FinManReconDetail",
        data:()=>({
            bread:{
                level:4,
                firstPath:{path: '/indexShow'},
                thirdPath:{path: '/indexDoMore'},
            },
            breadTaskToDo:{
                level:4,
                firstPath:{path: '/indexShow'},
                thirdPath:{path: '/taskToDo'},
            },
            breadTaskDone:{
                level:4,
                thirdPath:{path: '/taskDone'},
            },
            tableData:[],
            tableLoading:false,
            sum:'',
            tableStyle:GLOBAL.tableHeaderStyle,
            tableEdit:false,
            editable:[],
            detail:{
                companyName:'',
                period:'',
                roomList:[],
                url:'data:image/jpeg;base64,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',
                fileList:[
                    // {name:'checkUrl',url:'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1878154503,3922439519&fm=26&gp=0.jpg'}
                ],
                checkDialogVisible:false,
                roomDetailShow:false,
                urlDetailShow:false,
                totalAmount:'',
                price:'',
                automatic:''
            },
            headers:{},
            query:{},
            token:'',
            form:{
                price:''
            },
            isChange:false,
            reconciliationType:0,
            auth:{},
            tableShow:false,
            curPage:''

        }),
        methods:{
            blurMeth(){
                this.tableEdit=false;
            },
            uploadMeth(){
                this.detail.checkDialogVisible=true;
            },
            roomDetailMeth(){
                this.detail.roomDetailShow=!this.detail.roomDetailShow;
                var url='';
                var id='';
                this.reconciliationType===1 //上线
                    ?url=this.global.getRootReconciliationRoomsInfo
                    :url=this.global.getMarketReconciliationRoomsInfo;
                if(this.detail.roomDetailShow){
                    this.$http.get(url,{
                        params:{
                            token:this.token,
                            id:this.detail.reconciliationId
                        }
                    }).then(res=>{
                        if(res.data.code===100000){
                            this.detail.roomList=res.data.data;
                        }else{
                            this.$message.warning(res.data.msg);
                        }
                    }).catch(()=>{
                    })
                }
            },
            urlDetailMeth(){
                this.detail.urlDetailShow=!this.detail.urlDetailShow;
                // if(this.detail.urlDetailShow){
                //     if(this.detail.roomDetailShow){
                //         this.$http.get(this.global.getRootReconciliationRoomsInfo,{
                //             params:{
                //                 token:this.token,
                //                 id:this.query.id
                //             }
                //         }).then(res=>{
                //             console.log('获取所有财务房间信息',res);
                //             if(res.data.code===100000){
                //                 this.detail.roomList=res.data.data;
                //             }else{
                //                 this.$message.warning(res.data.msg);
                //             }
                //             this.table.loading=false;
                //         }).catch(()=>{
                //             this.table.loading=false;
                //         })
                //     }
                // }

            },
            tableMeth(){
                this.tableShow=false;
                this.tableLoading=true;
                this.$http.get(this.global.registerReviewDetail,{
                    params:{
                        token:this.token,
                        id:this.query.id
                    }
                }).then(res=>{
                    if(res.data.code===100000){
                        this.detail.fileList=[];
                        var resData=res.data.data;
                        this.reconciliationType=resData.reconciliationType;
                        this.detail.companyName=resData.partnerName;
                        this.detail.automatic=resData.automatic;
                        if(this.reconciliationType===1){   //上线
                            var obj={};
                            obj.hotelName=resData.hotelName;
                            obj.settleType=resData.settleType;
                            obj.terminalNum=resData.terminalNum;
                            obj.checkTerminalNum=resData.checkTerminalNum;
                            obj.receivingTime=resData.receivingTime;
                            obj.price=resData.price;
                            obj.amount=resData.amount;
                            this.tableData.push(obj);
                            this.form.price=resData.price;
                            this.detail.period=resData.createTime;
                            this.detail.fileList.push({name:'',url:resData.acceptance_form_url});
                            this.detail.reconciliationId=resData.reconciliationId;
                        }else{
                            this.tableData=resData.hotelList;
                            this.detail.period=resData.period;
                            this.detail.totalAmount=resData.totalAmount;
                            this.detail.price=resData.price;
                            this.form.price=resData.price;
                            this.detail.reconciliationId=resData.reconciliationId;
                        }
                        this.tableShow=true;
                    }else{
                        this.$message.warning(res.data.msg);
                    }
                    this.tableLoading=false;

                }).catch(()=>{
                    this.tableLoading=false;

                })
            },
            priceChange(val){
                this.isChange=true;
                this.detail.totalAmount=0;
                if(this.reconciliationType===1){   //上线
                    this.tableData.forEach((item,index)=>{
                        item.price=val;
                        item.amount=(item.price*1)*(item.checkTerminalNum*1);
                    });
                }else{
                    this.tableData.forEach((item,index)=>{
                        item.price=val;
                        item.amount=item.price*item.valid_room_num;
                        this.detail.totalAmount+=parseInt(item.amount);
                    });
                }
            },
            pass(){
                this.$confirm('确定通过?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.examine(1);
                }).catch(()=>{

                })
            },
            reject() {
                this.$refs.rejectDialog.dialogShow(true);
            },
            examine(status){
                var param=qs.stringify({
                    token:this.token,
                    id:this.query.id,
                    price:this.form.price,
                    status:status,
                    message:this.$refs.rejectDialog.dialog.reason,
                });
                this.$http.post(this.global.reconciliationAction,param).then(res=>{
                    if(res.data.code===100000){
                        this.$message.success('审核成功','success');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                    this.$router.push('/indexDoMore')
                });
            },

            arrUnique(arr){
                return Array.from(new Set(arr))
            },
            getTotal(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (column.property === 'amount') {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                // console.log('prev_curr-two',this.twoPointCom(prev));
                                // console.log('prev_curr-num',Number(this.twoPointCom(prev)));
                                // console.log('prev_curr',Number(this.twoPointCom(prev)) + Number(this.twoPointCom(curr)));
                                return this.twoPointCom(Number(this.twoPointCom(prev)) + Number(this.twoPointCom(curr)));
                            } else {
                                return prev;
                            }
                        }, 0);
                        this.twoPointCom(sums[index]);
                        var a='10.00';
                        var b='200.00';
                        console.log('c',Number(a)+Number(b));
                    } else {
                        sums[index] = '--';
                    }
                });

                return sums;
            },
            backMeth(){
                this.$router.push({path:`./${this.query.fromUrl}`})
            },

        },
        mounted(){
            this.token=sessionStorage.getItem('token');
            this.auth=JSON.parse(sessionStorage.getItem('auth'));
            this.curPage=sessionStorage.getItem('defaultActive');
            var query=this.$route.query;
            this.query=query;
            this.tableMeth();
        },
        watch:{
            tableData:{
                handler:function(newVal){
                    var sum=0;
                    if(newVal){
                        newVal.forEach((item,index)=>{
                            item.sum=item.price*item.checkNum;
                            sum+=parseInt(item.sum);
                        });
                        this.sum=sum;
                    }
                },
                deep:true,
            }
        },
        computed:{
            twoPointCom(){
                return function(x){
                    !x?x=0:'';
                    var f = parseFloat(x);
                    if (isNaN(f)) {
                        return false;
                    }
                    var f = Math.round(x*100)/100;
                    var s = f.toString();
                    var rs = s.indexOf('.');
                    if (rs < 0) {
                        rs = s.length;
                        s += '.';
                    }
                    while (s.length <= rs + 2) {
                        s += '0';
                    }
                    return s;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .marginBottomTwenty{
        margin-bottom:20px;
    }
    .title{
        text-align: center;
        font-weight:600;
    }
    .tips{
        color:#999999;
    }
    .tips p{
        font-size:12px;
        /*letter-spacing:1px;*/
    }
    .showDetailBox{
        color:#3085fc;
    }
    .showDetailBox span{
        cursor:pointer;
    }
    .detailBox{
        display:flex;
        justify-content: space-between;
    }
    .detailBox span{
        font-size:14px;
    }
    .roomItem{
        padding:10px;
        border-radius:4px;
        text-align: center;
        border:1px solid #ddd;
        cursor:pointer;
        position:relative;
    }
    .noneEl{
        visibility: hidden;
    }
    .totalMoney{
        padding-right:100px;
        text-align: right;
    }
    .roomItemBox{
        margin-bottom:10px;
    }
    .passBtn{
        margin-left:auto;
    }
    .outItem{
        border:1px solid #8aa4c2;
        margin-bottom:30px;
    }
    .top{
        display:flex;
        background:#f8fbff;
        height:50px;
        padding:0 10px;
        align-items: center;
        border-bottom:1px solid #e2e6eb;

        .right{
            margin-left:auto;
            .el-button{
                margin-right:20px;
            }
        }
        span{
            color:#2b466b;
            font-size:14px;
        }
    }
    .bottom{
        padding:20px;
        overflow:hidden;

        .item{
            display:flex;
            justify-content: space-between;
            margin-bottom:20px;
        }
        .item:last-child{
            margin-bottom:0;
        }
        .first{
            display:flex;
            align-items: center;
            font-size:14px;
        }
        .two{
            font-size:14px;
        }
        .innerInput{
            width:190px;
            margin:0 10px;
        }
        .hideInput{
            visibility: hidden;
        }
    }
</style>
